import { useState, useEffect, useRef } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import supabase from './supabaseClient';
import { sbGet, sbInsert, sbPatch, sbDelete } from './services/supabase-api';
import { initTE, initEA, initTM, initCar, initFlota, initDiaria, initSemanal, initMensual, initCont, initRotura } from './constants/formConfig';
import { AppLayout } from './components/AppLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LandingPage } from './components/LandingPage';
import { MasterLayout } from './components/MasterLayout';
import { RegistroFreeScreen } from './components/RegistroFreeScreen';
import { InformacionScreen } from './components/InformacionScreen';
import { RegistroCompletadoScreen } from './components/RegistroCompletadoScreen';
import { FreeLayout } from './components/FreeLayout';
import { FreeInicioSection } from './components/FreeInicioSection';
import { FreeCarretillaForm } from './components/FreeCarretillaForm';
import { FreeTranspaletaForm } from './components/FreeTranspaletaForm';
import { FreeMantenimientoForm } from './components/FreeMantenimientoForm';
import { FreeFlotaForm } from './components/FreeFlotaForm';
import { FreeVehiculoExpresForm } from './components/FreeVehiculoExpresForm';
import { FreeAjustesSection } from './components/FreeAjustesSection';
import { DescargasOperadores } from './components/DescargasOperadores';
import { SplashScreen } from './components/SplashScreen';
import { LoginScreen } from './components/LoginScreen';
import { InventarioSection } from './components/InventarioSection';
import { PendientesSection } from './components/PendientesSection';
import { ArchivoSection } from './components/ArchivoSection';
import { KPIsSection } from './components/KPIsSection';
import { InicioSection } from './components/InicioSection';
import { AlmacenSection } from './components/AlmacenSection';
import { FlotaSection } from './components/FlotaSection';
import { APPCCSection } from './components/APPCCSection';
import { ContenedorSDCSection } from './components/ContenedorSDCSection';
import { DocumentosSection } from './components/DocumentosSection';
import { HistorialSection } from './components/HistorialSection';
import { LlegadaSection } from './components/LlegadaSection';
import { LlegadaConfirmadaScreen } from './components/LlegadaConfirmadaScreen';
import { AjustesSection } from './components/AjustesSection';
import { EntradasSection } from './components/EntradasSection';
import { SalidasSection } from './components/SalidasSection';
import { FotosContenedorSection } from './components/FotosContenedorSection';
import { FacturacionSection } from './components/FacturacionSection';
import { InventarioInternacionalSection } from './components/InventarioInternacionalSection';
import { PedidosSection } from './components/PedidosSection';
import { ArchivoInternacionalSection } from './components/ArchivoInternacionalSection';
import { KPIsInternacionalSection } from './components/KPIsInternacionalSection';
import { VoldisInternacionalSection } from './components/VoldisInternacionalSection';
import { QRDesactivadoScreen } from './components/QRDesactivadoScreen';

// Modos de acceso por QR habilitados. QR de operario desactivado de momento: añadir "operario" para reactivarlo.
const MODOS_QR = ["operador"];

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loginUser, setLoginUser] = useState("");
  const [loginPass, setLoginPass] = useState("");
  const [loginErr, setLoginErr] = useState("");
  const [currentUser, setCurrentUser] = useState(null);
  const [almTab, setAlmTab] = useState("Transpaleta Eléctrica");
  const [appccTab, setAppccTab] = useState("Diaria");
  const [historial, setHistorial] = useState([]);
  const [archivo, setArchivo] = useState([]);
const [equipos, setEquipos] = useState([]);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);
  const [doc, setDoc] = useState({ operario: "", titulo: "", descripcion: "", archivo: null, preview: null });
const [docSubiendo, setDocSubiendo] = useState(false);
  const [confirmEliminar, setConfirmEliminar] = useState(null);
const [modalValidar, setModalValidar] = useState(null); // { id } 
const [validadoPor, setValidadoPor] = useState("");
  const [modoQR, setModoQR] = useState(false);
  const [sessionChecked, setSessionChecked] = useState(false);
const [llegada, setLlegada] = useState({ nombre_conductor: "", empresa: "", matricula: "", hora_llegada: "" });
const [llegadas, setLlegadas] = useState([]);
  const [te, setTE] = useState(initTE());
  const [ea, setEA] = useState(initEA());
  const [tm, setTM] = useState(initTM());
  const [car, setCar] = useState(initCar());
  const [flota, setFlota] = useState(initFlota());
  const [diaria, setDiaria] = useState(initDiaria());
  const [semanal, setSemanal] = useState(initSemanal());
  const [mensual, setMensual] = useState(initMensual());
  const [cont, setCont] = useState(initCont());
  const [rotura, setRotura] = useState(initRotura());
  const [reserva, setReserva] = useState({ nombre: "", equipo: "", dia: "", horaRecogida: "", horaDevolucion: "", observaciones: "" });
const firmaMensualRef = useRef(null);
const [firmaMensualDibujada, setFirmaMensualDibujada] = useState(false);
const [dibujandoMensual, setDibujandoMensual] = useState(false);const limpiarFirmaMensual = () => { const canvas = firmaMensualRef.current; if (canvas) { const ctx = canvas.getContext("2d"); ctx.clearRect(0, 0, canvas.width, canvas.height); } setFirmaMensualDibujada(false); };
const getPosMensual = (e, canvas) => { const rect = canvas.getBoundingClientRect(); const clientX = e.touches ? e.touches[0].clientX : e.clientX; const clientY = e.touches ? e.touches[0].clientY : e.clientY; return { x: clientX - rect.left, y: clientY - rect.top }; };

 const qrHandledRef = useRef(false);
 useEffect(() => {
  if (qrHandledRef.current) return;
  qrHandledRef.current = true;
  const init = async () => {
    const params = new URLSearchParams(window.location.search);
    const modo = params.get("modo");
    if (!modo) return;
    if (!MODOS_QR.includes(modo)) { navigate("/qr-desactivado", { replace: true, state: { modo } }); return; }
    const almacen_id = params.get("almacen");
    try {
      const r = await fetch("https://fmzyvyhgqhrpfpsdwtcu.supabase.co/functions/v1/qr-login-almacen", {
        method: "POST",
        headers: { "Content-Type": "application/json", "apikey": process.env.REACT_APP_SB_KEY, "Authorization": `Bearer ${process.env.REACT_APP_SB_KEY}` },
        body: JSON.stringify({ almacen_id, rol: modo }),
      });
      const { token_hash } = await r.json().catch(() => ({}));
      if (!r.ok || !token_hash) { navigate("/app", { replace: true }); return; }

      const { data: verifyData, error: verifyError } = await supabase.auth.verifyOtp({ token_hash, type: "magiclink" });
      if (verifyError || !verifyData?.session) { navigate("/app", { replace: true }); return; }

      const almacenIdReal = verifyData.session.user.app_metadata?.almacen_id;
      const { data: almacenData } = await supabase.from('almacenes').select('nombre, modulos, siglas, color').eq('id', almacenIdReal).single();
      const label = modo === "operador" ? "🚚 Transportista" : "🧑 Operario";
      setCurrentUser({ user: verifyData.session.user.email, rol: modo, label, almacen_id: almacenIdReal, modulos: almacenData?.modulos || {}, siglas: almacenData?.siglas || "", color: almacenData?.color || "#6b7280", almacen_nombre: almacenData?.nombre || "" });
      setModoQR(true);
      if (modo === "operador") {
        navigate("/app/home/llegada", { replace: true });
      } else {
        navigate("/app/home/inicio", { replace: true });
        cargarHistorial(almacenIdReal);
        cargarEquipos(almacenIdReal);
      }
    } catch {
      navigate("/app", { replace: true });
    }
  };
  init();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

 const sessionCheckedRef = useRef(false);
 useEffect(() => {
  if (sessionCheckedRef.current) return;
  sessionCheckedRef.current = true;
  const restoreSession = async () => {
    if (new URLSearchParams(window.location.search).get("modo")) { setSessionChecked(true); return; }
    try {
      let { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        let rol = session.user.app_metadata?.rol;
        const almacen_id = session.user.app_metadata?.almacen_id;
        let recienCompletado = false;

        // ── Registro FREE recién confirmado por email: todavía sin rol asignado ──
        if (!rol) {
          const { data: cuentaExistente } = await supabase.from('cuentas').select('id').eq('user_id', session.user.id).maybeSingle();
          if (!cuentaExistente) {
            const { error: completarError } = await supabase.functions.invoke('completar-registro-free');
            if (completarError) {
              setSessionChecked(true);
              navigate("/registro", { replace: true });
              return;
            }
            recienCompletado = true;
          }
          const { data: refreshed } = await supabase.auth.refreshSession();
          session = refreshed.session || session;
          rol = session.user.app_metadata?.rol;
        }

        const labelMap = { responsable: "✅ Administrador", operario: "🧑 Operario", superadmin: "🛡️ Super Admin", cliente: "🆓 Plan Free" };
        if (rol === "superadmin") {
          setCurrentUser({ user: session.user.email, rol, label: labelMap.superadmin });
          if (!window.location.pathname.startsWith("/master")) navigate("/master", { replace: true });
        } else if (rol === "cliente") {
          setCurrentUser({ user: session.user.email, rol, label: labelMap.cliente });
          if (recienCompletado) {
            navigate("/registro/completado", { replace: true });
          } else if (!window.location.pathname.startsWith("/app/free")) {
            navigate("/app/free/inicio", { replace: true });
          }
        } else {
          const { data: almacenData } = await supabase.from('almacenes').select('nombre, modulos, siglas, color').eq('id', almacen_id).single();
          setCurrentUser({ user: session.user.email, rol, label: labelMap[rol] || "🧑 Operario", almacen_id, modulos: almacenData?.modulos || {}, siglas: almacenData?.siglas || "", color: almacenData?.color || "#6b7280", almacen_nombre: almacenData?.nombre || "" });
          if (!window.location.pathname.startsWith("/app/home")) {
            navigate(`/app/home/${rol === "responsable" ? "pendientes" : "inicio"}`, { replace: true });
          }
        }
      }
    } catch {
    } finally {
      setSessionChecked(true);
    }
  };
  restoreSession();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

useEffect(() => {
   
  
if (currentUser?.almacen_id) {
    cargarHistorial(currentUser.almacen_id); 
    cargarEquipos(currentUser.almacen_id); 
    supabase.from('registro_llegadas').select('*').eq('almacen_id', currentUser?.almacen_id).order('created_at', { ascending: false })
      .then(({ data }) => setLlegadas(data || []))
      .catch(() => {});
  }
 // eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentUser?.almacen_id]);
// eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => { const slug = location.pathname.split('/').pop(); if (slug === "inventario" || slug === "kpis") cargarEquipos(); }, [location.pathname]);

  const cargarEquipos = async (aid) => {
    const almacen = aid || currentUser?.almacen_id;
  try {
    const { data, error } = await supabase.from('Equipos').select('*').eq('almacen_id', almacen).order('Nombre', { ascending: true });
    if (error) return;
    setEquipos(data);
    const primerTE = data.find(e => e.Activo && e.Nombre.startsWith("TE-"))?.Nombre || "";
const primerTM = data.find(e => e.Activo && e.Nombre.startsWith("TM-"))?.Nombre || "";
const primerCar = data.find(e => e.Activo && e.Nombre.startsWith("CE-"))?.Nombre || "";
const primerReserva = data.find(e => e.Activo && (e.Nombre.startsWith("TE-") || e.Nombre.startsWith("TM-")))?.Nombre || "";
setTE(s => ({ ...s, equipo: primerTE }));
setTM(s => ({ ...s, equipo: primerTM }));
const primerEA = data.find(e => e.Activo && ["BR-","FL-"].some(p => e.Nombre.startsWith(p)))?.Nombre || "";
setEA(s => ({ ...s, equipo: primerEA }));
setCar(s => ({ ...s, equipo: primerCar }));
setReserva(s => ({ ...s, equipo: primerReserva }));
  } catch { }
};

const cargarHistorial = async (aid) => {
    const almacen = aid || currentUser?.almacen_id;
    
    if (!almacen) return;
    setLoading(true);
    const rows = await sbGet(almacen);
    const pendientes = rows.filter(r => r.estado === "pendiente").map(r => ({ id: r.id, tipo: r.tipo, fecha: r.fecha, hora: r.hora, datos: r.datos, estado: r.estado, validado_por: r.validado_por || "" }));
    const validados = rows.filter(r => r.estado === "validado").map(r => ({ id: r.id, tipo: r.tipo, fecha: r.fecha, hora: r.hora, datos: r.datos, estado: r.estado, validado_por: r.validado_por || "" }));
    setHistorial(pendientes);
    setArchivo(validados);
    setLoading(false);
  };

 const handleLogin = async () => {
    setLoginErr("");
    setLoading(true);
    try {
      const { data, error } = await supabase.auth.signInWithPassword({ email: loginUser.trim().toLowerCase(), password: loginPass });
      setLoading(false);
      if (error || !data.user) {
        setLoginErr("Usuario o contraseña incorrectos.");
        return;
      }
      const rol = data.user.app_metadata?.rol;
      const almacen_id = data.user.app_metadata?.almacen_id;
      const labelMap = { responsable: "✅ Administrador", operador: "🚚 Transportista", operario: "🧑 Operario", superadmin: "🛡️ Super Admin", cliente: "🆓 Plan Free" };
      if (rol === "superadmin") {
        setCurrentUser({ user: data.user.email, rol, label: labelMap.superadmin });
        navigate("/master", { replace: true });
        return;
      }
      if (rol === "cliente") {
        setCurrentUser({ user: data.user.email, rol, label: labelMap.cliente });
        navigate("/app/free/inicio", { replace: true });
        return;
      }
      const { data: almacenData } = await supabase.from('almacenes').select('nombre, modulos, siglas, color').eq('id', almacen_id).single();
      setCurrentUser({ user: data.user.email, rol, label: labelMap[rol] || "🧑 Operario", almacen_id, modulos: almacenData?.modulos || {}, siglas: almacenData?.siglas || "", color: almacenData?.color || "#6b7280", almacen_nombre: almacenData?.nombre || "" });
      const homeSlug = rol === "responsable" ? "pendientes" : rol === "operador" ? "llegada" : "inicio";
      navigate(`/app/home/${homeSlug}`, { replace: true });
    } catch (e) {
      setLoading(false);
      setLoginErr("Error de conexión.");
    }
  };

  const guardar = async (tipo, datos) => {
  const fecha = new Date().toLocaleDateString("es-ES");
  const hora = new Date().toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
  const res = await sbInsert({ tipo, fecha, hora, datos, estado: "pendiente", usuario: currentUser?.user, almacen_id: currentUser?.almacen_id });
  if (res) {
    setHistorial(h => [{ id: res[0].id, tipo, fecha, hora, datos, estado: "pendiente" }, ...h]);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
    fetch("https://fmzyvyhgqhrpfpsdwtcu.supabase.co/functions/v1/enviar-notificacion", { method: "POST", headers: { "Content-Type": "application/json", "Authorization": `Bearer ${process.env.REACT_APP_SB_KEY}` }, body: JSON.stringify({ tipo, equipo: datos?.equipo || "", nombre: datos?.nombre || "", fecha, hora, observaciones: datos?.observaciones || "", datos: datos ?? null, debug: typeof datos, almacen_id: currentUser?.almacen_id }) });
    if (modoQR) {
      setTimeout(async () => {
        await supabase.auth.signOut({ scope: "local" });
        navigate("/app");
        setCurrentUser(null);
        setModoQR(false);
      }, 2000);
    }
  }
};

  const rechazar = async (id) => {
    await sbDelete(id);
    setHistorial(h => h.filter(r => r.id !== id));
  };

  const eliminarArchivado = async (id) => {
    await sbDelete(id);
    setArchivo(a => a.filter(r => r.id !== id));
    setConfirmEliminar(null);
  };

  const rol = currentUser?.rol;

  // Alertas
  const ahora = new Date();
  const hace7dias = new Date(ahora - 7 * 24 * 60 * 60 * 1000);
  const hace24h = new Date(ahora - 24 * 60 * 60 * 1000);
  const hace18dias = new Date(ahora - 18 * 24 * 60 * 60 * 1000);
  const todosRegistros = [...historial, ...archivo];

  const almacenHabilitado = currentUser?.modulos?.almacen === true;

  const tiposEquipo = ["Transpaleta Eléctrica", "Transpaleta Manual", "Carretilla", "Equipos Almacén"];
  const alertasEquipos = almacenHabilitado ? equipos.filter(eq => eq.Activo && tiposEquipo.some(t => {
    if (t === "Transpaleta Eléctrica" && !eq.Nombre.startsWith("TE-")) return false;
    if (t === "Transpaleta Manual" && !eq.Nombre.startsWith("TM-")) return false;
    if (t === "Carretilla" && !["CE-","CR-","PP-","PPF-"].some(p => eq.Nombre.startsWith(p))) return false;
    if (t === "Equipos Almacén" && !["BR-","FL-"].some(p => eq.Nombre.startsWith(p))) return false;
    return !todosRegistros.some(r => r.tipo === t && r.datos?.equipo === eq.Nombre && new Date(r.fecha.split("/").reverse().join("-")) >= hace7dias);
  })).map(eq => ({ msg: `⚠️ ${eq.Nombre} sin revisión hace más de 7 días`, color: "bg-yellow-50 border-yellow-300 text-yellow-800" })) : [];

  const appccHabilitado = currentUser?.modulos?.appcc === true;

  const alertasDiaria = appccHabilitado && !todosRegistros.some(r => r.tipo === "APPCC Diaria" && new Date(r.fecha.split("/").reverse().join("-")) >= hace24h)
    ? [{ msg: "🧹 APPCC Diaria — Sin verificación en las últimas 24h", color: "bg-orange-50 border-orange-300 text-orange-800" }] : [];

  const alertasSemanal = appccHabilitado && !todosRegistros.some(r => r.tipo.startsWith("APPCC Semanal") && new Date(r.fecha.split("/").reverse().join("-")) >= hace7dias)
    ? [{ msg: "🗓️ APPCC Semanal — Sin check en los últimos 7 días", color: "bg-orange-50 border-orange-300 text-orange-800" }] : [];

  const alertasMensual = appccHabilitado && !todosRegistros.some(r => r.tipo.startsWith("APPCC Mensual") && new Date(r.fecha.split("/").reverse().join("-")) >= hace18dias)
    ? [{ msg: "🗓️ APPCC Mensual — Sin check en los últimos 18 días", color: "bg-red-50 border-red-300 text-red-800" }] : [];

  const alertas = currentUser?.rol === "operario" ? [...alertasEquipos, ...alertasDiaria, ...alertasSemanal, ...alertasMensual] : [];

  if (!sessionChecked) return null;

  // ── APP (autenticada) ──────────────────────────────────────────
  const homeSlug = rol === "responsable" ? "pendientes" : rol === "operador" ? "llegada" : "inicio";

  return (
    <Routes>
      <Route path="/" element={
        new URLSearchParams(location.search).get("modo")
          ? <Navigate to={{ pathname: "/app", search: location.search }} replace />
          : <LandingPage />
      } />
      <Route path="/app" element={<SplashScreen />} />
      <Route path="/informacion" element={<InformacionScreen />} />
      <Route path="/qr-desactivado" element={<QRDesactivadoScreen />} />
      <Route path="/registro" element={<RegistroFreeScreen />} />
      <Route path="/registro/completado" element={<RegistroCompletadoScreen currentUser={currentUser} setCurrentUser={setCurrentUser} setLoginUser={setLoginUser} setLoginPass={setLoginPass} />} />
      <Route
        path="/app/login"
        element={
          <LoginScreen
            loginUser={loginUser}
            setLoginUser={setLoginUser}
            loginPass={loginPass}
            setLoginPass={setLoginPass}
            loginErr={loginErr}
            setLoginErr={setLoginErr}
            loading={loading}
            handleLogin={handleLogin}
          />
        }
      />
      <Route path="/app/llegada-confirmada" element={<LlegadaConfirmadaScreen setCurrentUser={setCurrentUser} />} />

      <Route
        path="/app/home"
        element={
          currentUser ? (
            <AppLayout
              currentUser={currentUser} rol={rol}
              setLoginUser={setLoginUser} setLoginPass={setLoginPass} setCurrentUser={setCurrentUser}
              historial={historial} saved={saved} alertas={alertas} almTab={almTab}
              modalValidar={modalValidar} setModalValidar={setModalValidar} validadoPor={validadoPor} setValidadoPor={setValidadoPor}
              onConfirmValidar={async () => {
                await sbPatch(modalValidar.id, { estado: "validado", validado_por: validadoPor.trim() });
                const reg = historial.find(r => r.id === modalValidar.id);
                if (reg) {
                  setArchivo(a => [{ ...reg, estado: "validado", validado_por: validadoPor.trim() }, ...a]);
                  setHistorial(h => h.filter(r => r.id !== modalValidar.id));
                }
                setModalValidar(null);
                setValidadoPor("");
              }}
              confirmEliminar={confirmEliminar} setConfirmEliminar={setConfirmEliminar}
              onConfirmEliminarArchivado={eliminarArchivado}
            />
          ) : <Navigate to="/app" replace />
        }
      >
        <Route index element={<Navigate to={`/app/home/${homeSlug}`} replace />} />

        {/* ══ ADMIN: PENDIENTES ══ */}
        <Route path="pendientes" element={
          <ProtectedRoute rol={rol} allowedRoles={["responsable"]}>
            <PendientesSection
              historial={historial}
              loading={loading}
              cargarHistorial={cargarHistorial}
              setLlegadas={setLlegadas}
              almacen_id={currentUser?.almacen_id}
              onValidar={(id) => { setModalValidar({ id }); setValidadoPor(""); }}
              onRechazar={rechazar}
            />
          </ProtectedRoute>
        } />

        {/* ══ ADMIN: ARCHIVO ══ */}
        <Route path="archivo" element={
          <ProtectedRoute rol={rol} allowedRoles={["responsable"]}>
            <ArchivoSection archivo={archivo} currentUser={currentUser} onEliminar={(id) => setConfirmEliminar(id)} />
          </ProtectedRoute>
        } />

        {/* ══ ADMIN: AJUSTES ══ */}
        <Route path="ajustes" element={
          <ProtectedRoute rol={rol} allowedRoles={["responsable"]}>
            <AjustesSection currentUser={currentUser} />
          </ProtectedRoute>
        } />

        {/* ══ ADMIN: INVENTARIO ══ */}
        <Route path="inventario" element={
          <ProtectedRoute rol={rol} allowedRoles={["responsable"]}>
            <InventarioSection equipos={equipos} setEquipos={setEquipos} currentUser={currentUser} />
          </ProtectedRoute>
        } />

        {/* ══ ADMIN: KPIs ══ */}
        <Route path="kpis" element={
          <ProtectedRoute rol={rol} allowedRoles={["responsable"]}>
            <KPIsSection
              historial={historial}
              archivo={archivo}
              llegadas={llegadas}
              equipos={equipos}
              cargarHistorial={cargarHistorial}
              alertasEquipos={alertasEquipos}
              alertasDiaria={alertasDiaria}
              alertasSemanal={alertasSemanal}
              alertasMensual={alertasMensual}
              almacen_id={currentUser?.almacen_id}
            />
          </ProtectedRoute>
        } />

        {/* ══ ADMIN: INTERNACIONAL (solo Voldis) ══ */}
        <Route path="internacional" element={
          <ProtectedRoute rol={rol} allowedRoles={["responsable"]} allowed={currentUser?.almacen_id === "cb60fe34-e079-4e36-8bd9-f5f5c3a1f21c"}>
            <VoldisInternacionalSection />
          </ProtectedRoute>
        } />

        {/* ══ ADMIN: DESCARGAS OPERADORES ══ */}
        <Route path="descargas" element={
          <ProtectedRoute rol={rol} allowedRoles={["responsable"]}>
            <DescargasOperadores
              llegadas={llegadas}
              setLlegadas={setLlegadas}
              cargarLlegadas={async () => {
                const { data } = await supabase.from('registro_llegadas').select('*').eq('almacen_id', currentUser?.almacen_id).order('created_at', { ascending: false });
                setLlegadas(data || []);
              }}
            />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO: INICIO ══ */}
        <Route path="inicio" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]}>
            <InicioSection setAlmTab={setAlmTab} historial={historial} modulos={currentUser?.modulos} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO: ALMACÉN ══ */}
        <Route path="almacen" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.almacen === true}>
            <AlmacenSection
              almTab={almTab} setAlmTab={setAlmTab} equipos={equipos} historial={historial} archivo={archivo} guardar={guardar}
              te={te} setTE={setTE} tm={tm} setTM={setTM} car={car} setCar={setCar} ea={ea} setEA={setEA}
              reserva={reserva} setReserva={setReserva} rotura={rotura} setRotura={setRotura}
            />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO: FLOTA ══ */}
        <Route path="flota" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.flota === true}>
            <FlotaSection flota={flota} setFlota={setFlota} guardar={guardar} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO: APPCC ══ */}
        <Route path="appcc" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.appcc === true}>
            <APPCCSection
              appccTab={appccTab} setAppccTab={setAppccTab} guardar={guardar}
              diaria={diaria} setDiaria={setDiaria} semanal={semanal} setSemanal={setSemanal} mensual={mensual} setMensual={setMensual}
              firmaMensualRef={firmaMensualRef} firmaMensualDibujada={firmaMensualDibujada} setFirmaMensualDibujada={setFirmaMensualDibujada}
              dibujandoMensual={dibujandoMensual} setDibujandoMensual={setDibujandoMensual}
              limpiarFirmaMensual={limpiarFirmaMensual} getPosMensual={getPosMensual}
            />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO: CONTENEDOR SDC ══ */}
        <Route path="contenedor-sdc" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.contenedor_sdc === true}>
            <ContenedorSDCSection cont={cont} setCont={setCont} guardar={guardar} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO: DOCUMENTOS ══ */}
        <Route path="documentos" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.documentos === true}>
            <DocumentosSection doc={doc} setDoc={setDoc} docSubiendo={docSubiendo} setDocSubiendo={setDocSubiendo} guardar={guardar} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO: HISTORIAL ══ */}
        <Route path="historial" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.historial === true}>
            <HistorialSection historial={historial} loading={loading} cargarHistorial={cargarHistorial} />
          </ProtectedRoute>
        } />

        {/* ══ OPERADOR: LLEGADA ══ */}
        <Route path="llegada" element={
          <ProtectedRoute rol={rol} allowedRoles={["operador"]}>
            <LlegadaSection llegada={llegada} setLlegada={setLlegada} currentUser={currentUser} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO: ENTRADAS CAMIONES ══ */}
        <Route path="entradas" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.entradas === true}>
            <EntradasSection currentUser={currentUser} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO: SALIDAS CONTENEDORES ══ */}
        <Route path="salidas" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.salidas === true}>
            <SalidasSection currentUser={currentUser} guardar={guardar} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO: FOTOS CONTENEDOR ══ */}
        <Route path="fotos-contenedor" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.fotos_contenedor === true}>
            <FotosContenedorSection currentUser={currentUser} guardar={guardar} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO: FACTURACIÓN ══ */}
        <Route path="facturacion" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.facturacion === true}>
            <FacturacionSection currentUser={currentUser} guardar={guardar} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO (INTERNACIONAL): INVENTARIO ══ */}
        <Route path="inventario-stock" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.inventario === true}>
            <InventarioInternacionalSection currentUser={currentUser} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO (INTERNACIONAL): PEDIDOS ══ */}
        <Route path="pedidos" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.pedidos === true}>
            <PedidosSection currentUser={currentUser} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO (INTERNACIONAL): ARCHIVO DOCUMENTAL ══ */}
        <Route path="archivo-internacional" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.archivo === true}>
            <ArchivoInternacionalSection currentUser={currentUser} />
          </ProtectedRoute>
        } />

        {/* ══ OPERARIO (INTERNACIONAL): PANEL KPIs ══ */}
        <Route path="kpis-internacional" element={
          <ProtectedRoute rol={rol} allowedRoles={["operario"]} allowed={currentUser?.modulos?.kpis === true}>
            <KPIsInternacionalSection currentUser={currentUser} />
          </ProtectedRoute>
        } />

        <Route path="*" element={<Navigate to={`/app/home/${homeSlug}`} replace />} />
      </Route>

      {/* ══ PLAN FREE: DASHBOARD (andamiaje) ══ */}
      <Route
        path="/app/free"
        element={
          currentUser ? (
            <FreeLayout setCurrentUser={setCurrentUser} setLoginUser={setLoginUser} setLoginPass={setLoginPass} />
          ) : <Navigate to="/app" replace />
        }
      >
        <Route index element={<Navigate to="/app/free/inicio" replace />} />
        <Route path="inicio" element={
          <ProtectedRoute rol={rol} allowedRoles={["cliente"]}>
            <FreeInicioSection />
          </ProtectedRoute>
        } />
        <Route path="carretillas" element={
          <ProtectedRoute rol={rol} allowedRoles={["cliente"]}>
            <FreeCarretillaForm />
          </ProtectedRoute>
        } />
        <Route path="transpaletas" element={
          <ProtectedRoute rol={rol} allowedRoles={["cliente"]}>
            <FreeTranspaletaForm />
          </ProtectedRoute>
        } />
        <Route path="mantenimiento" element={
          <ProtectedRoute rol={rol} allowedRoles={["cliente"]}>
            <FreeMantenimientoForm />
          </ProtectedRoute>
        } />
        <Route path="flota" element={
          <ProtectedRoute rol={rol} allowedRoles={["cliente"]}>
            <FreeFlotaForm />
          </ProtectedRoute>
        } />
        <Route path="vehiculo-expres" element={
          <ProtectedRoute rol={rol} allowedRoles={["cliente"]}>
            <FreeVehiculoExpresForm />
          </ProtectedRoute>
        } />
        <Route path="ajustes" element={
          <ProtectedRoute rol={rol} allowedRoles={["cliente"]}>
            <FreeAjustesSection />
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/app/free/inicio" replace />} />
      </Route>

      {/* ══ SUPERADMIN: PANEL MASTER ══ */}
      <Route path="/master" element={
        currentUser?.rol === "superadmin" ? (
          <MasterLayout currentUser={currentUser} setLoginUser={setLoginUser} setLoginPass={setLoginPass} setCurrentUser={setCurrentUser} />
        ) : <Navigate to="/app" replace />
      } />

      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  );
}
